import { useEffect, useState } from 'react';
import Modal from '../Modal';
import { repositorioCentroCusto } from '../../sync/repositories/financeiro';
import { extrairMensagensErro } from '../../utils/errorUtils';

/**
 * Modal de cadastro rápido de Centro de Custo.
 * Só pede o nome — os demais dados são complementados na tela de
 * Gestão de Centro de Custo, se necessário.
 */
export default function ModalCadastroCentroCusto({ isOpen, onClose, onSuccess }) {
  const [nome, setNome] = useState('');
  const [salvando, setSalvando] = useState(false);
  const [erros, setErros] = useState([]);

  useEffect(() => {
    if (!isOpen) {
      setNome('');
      setErros([]);
      setSalvando(false);
    }
  }, [isOpen]);

  const handleSalvar = async (e) => {
    e?.preventDefault?.();
    if (!nome.trim()) { setErros(['O nome é obrigatório.']); return; }
    setSalvando(true);
    setErros([]);
    try {
      const resp = await repositorioCentroCusto.criar({ nome: nome.trim() });
      onSuccess?.(resp.data);
      onClose?.();
    } catch (error) {
      setErros(extrairMensagensErro(error));
    } finally {
      setSalvando(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={salvando ? () => {} : onClose} title="Cadastrar Centro de Custo">
      <form onSubmit={handleSalvar} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Nome *</label>
          <input
            type="text"
            value={nome}
            onChange={(e) => setNome(e.target.value)}
            className="w-full border border-gray-300 p-2 rounded focus:ring-2 focus:ring-green-300"
            placeholder="Ex: Talhão Norte, Administrativo..."
            autoFocus
            disabled={salvando}
          />
        </div>
        {erros.length > 0 && (
          <div className="bg-red-50 border border-red-200 text-red-700 text-sm rounded p-3 space-y-1">
            {erros.map((m, i) => <div key={i}>{m}</div>)}
          </div>
        )}
        <div className="flex justify-end gap-2 pt-2">
          <button type="button" onClick={onClose} disabled={salvando}
            className="px-4 py-2 rounded border border-gray-300 text-gray-700 hover:bg-gray-100 disabled:opacity-50">
            Cancelar
          </button>
          <button type="submit" disabled={salvando}
            className="px-4 py-2 rounded bg-blue-600 hover:bg-blue-700 text-white disabled:bg-blue-300">
            {salvando ? 'Salvando...' : 'Salvar'}
          </button>
        </div>
      </form>
    </Modal>
  );
}
